const fields = [
  'UE_Umfang_PC_AbstimmungNetzbetreiber',
  'UE_Umfang_PC_Trafoplanung',
]

const key = "Umfang der Angebotsstellung"

export const fieldOrderUmfangDerAngebotsstellung = { [key]: { fields } }
export const formGroupUmfangDerAngebotsstellung = {
  key,
  title: key,
  form: key,
}